import { useEffect } from 'react';
import './landing.css';
import { Nav } from './sections/Nav.js';
import { Hero } from './sections/Hero.js';
import { TheDay } from './sections/TheDay.js';
import { Manifesto } from './sections/Manifesto.js';
import { Iconostasis } from './sections/Iconostasis.js';
import { SacredWords } from './sections/SacredWords.js';
import { DailyRhythm } from './sections/DailyRhythm.js';
import { ModulesGrid } from './sections/ModulesGrid.js';
import { Capabilities } from './sections/Capabilities.js';
import { LiturgicalEngine } from './sections/LiturgicalEngine.js';
import { BothWorlds } from './sections/BothWorlds.js';
import { Voices } from './sections/Voices.js';
import { FAQ } from './sections/FAQ.js';
import { Feedback } from './sections/Feedback.js';
import { Support } from './sections/Support.js';
import { FinalCTA } from './sections/FinalCTA.js';
import { Footer } from './sections/Footer.js';
import { BackToTop } from './components/BackToTop.js';

export default function LandingPage() {
  // Set page-level OpenGraph + meta tags imperatively (no SSR helmet in this app).
  useEffect(() => {
    const prev = document.title;
    document.title = 'Orthodox Way • A small, quiet room you walk into before the world gets loud.';
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="ow-landing bg-bg text-primary">
      <a href="#main" className="ow-skip">
        Skip to main content
      </a>
      <Nav />
      <main id="main">
        <Hero />
        <TheDay />
        <Manifesto />
        <Iconostasis />
        <SacredWords />
        <DailyRhythm />
        <ModulesGrid />
        <Capabilities />
        <LiturgicalEngine />
        <BothWorlds />
        <Voices />
        <FAQ />
        <Feedback />
        <Support />
        <FinalCTA />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}
